export default __webpack_public_path__ + "static/media/cartoon-sparkle.186eb8e0.wav";